<template>
  <div>
    <label class="block">
      <span
        :class="buttonClass"
      >
        <slot>{{ $t('Choose files') }}</slot>
        <input
          v-if="!disabled"
          ref="fileinput"
          class="fileinput-upload"
          style="display: none"
          type="file"
          multiple
          @change="handleFileChange"
        />
      </span>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    buttonClass: { type: String, default: 'btn btn-primary btn-block btn-sm' },
    multiple: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    blockedFilenames: { type: Array, default: () => [] },
    openOnMounted: { type: Boolean, default: false },
  },
  mounted() {
    if (this.openOnMounted) {
      this.$refs.fileinput.click()
    }
  },
  methods: {
    handleFileChange(e) {
      const files = e.target.files || e.dataTransfer.files
      const attemptingUploadOfBlockedFilenames = Object.values(files)
        .map((file) => file.name)
        .some((incomingFilename) => this.blockedFilenames.includes(incomingFilename))
      if (attemptingUploadOfBlockedFilenames) {
        this.$emit('duplicateFileAttempted')
      } else {
        this.$emit('filesSelected', files)
      }
    },
  },
}
</script>

<style scoped></style>
